import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalTitle,
  PageDescription,
  FormGroup,
  Label,
  Input,
  PriceInputGroup,
  ButtonGroup,
  Button,
} from '../PriceListsPage.style';
import { getCurrencySymbol } from '../../../lib/formatCurrency';

const AddTyreModal = ({
  isOpen,
  onClose,
  onSubmit,
  formData,
  onFormChange,
}) => {
  const { t } = useTranslation();
  const currencySymbol = getCurrencySymbol();

  if (!isOpen) return null;

  return (
    <Modal>
      <div onClick={onClose} style={{ position: 'absolute', inset: 0 }} />
      <ModalContent>
        <ModalHeader>
          <ModalTitle>{t('addTyre')}</ModalTitle>
          {formData.pricelistLabel && (
            <PageDescription>
              {formData.pricelistLabel}
            </PageDescription>
          )}
        </ModalHeader>

        <form onSubmit={onSubmit}>
          <FormGroup>
            <Label htmlFor="dimension">{t('dimension')}</Label>
            <Input
              id="dimension"
              name="dimension"
              type="text"
              value={formData.dimension}
              onChange={(e) => onFormChange('dimension', e.target.value)}
              placeholder={t('dimensionPlaceholder')}
              required
            />
          </FormGroup>

          <FormGroup>
            <Label htmlFor="model">{t('model')}</Label>
            <Input
              id="model"
              name="model"
              type="text"
              value={formData.model}
              onChange={(e) => onFormChange('model', e.target.value)}
              placeholder={t('enterTyreModel')}
              required
            />
          </FormGroup>

          <PriceInputGroup>
            <FormGroup>
              <Label htmlFor="bruto">{t('grossLabel')} ({currencySymbol})</Label>
              <Input
                id="bruto"
                name="bruto"
                type="number"
                step="0.01"
                min="0"
                value={formData.bruto}
                onChange={(e) => onFormChange('bruto', e.target.value)}
                placeholder="0.00"
                required
              />
            </FormGroup>

            <FormGroup>
              <Label htmlFor="neto">{t('netLabel')} ({currencySymbol})</Label>
              <Input
                id="neto"
                name="neto"
                type="number"
                step="0.01"
                min="0"
                value={formData.neto}
                onChange={(e) => onFormChange('neto', e.target.value)}
                placeholder="0.00"
                required
              />
            </FormGroup>

            <FormGroup>
              <Label htmlFor="brutoZPopustom">{t('withDiscountLabel')} ({currencySymbol})</Label>
              <Input
                id="brutoZPopustom"
                name="brutoZPopustom"
                type="number"
                step="0.01"
                min="0"
                value={formData.brutoZPopustom}
                onChange={(e) => onFormChange('brutoZPopustom', e.target.value)}
                placeholder="0.00"
                required
              />
            </FormGroup>
          </PriceInputGroup>

          <ButtonGroup>
            <Button type="button" onClick={onClose}>
              {t('cancel')}
            </Button>
            <Button type="submit" $primary>
              {t('addTyre')}
            </Button>
          </ButtonGroup>
        </form>
      </ModalContent>
    </Modal>
  );
};

export default AddTyreModal;

